import { createReducer, on } from "@ngrx/store";
import { CartActions } from "./cart.actions";
import { CartAdapter, InitialCartState } from "./cart.entity";

export const CartReducer = createReducer(
  InitialCartState,
  on(CartActions.initializeCart, (state, { initialized }) => ({ ...state, initialized })),
  on(CartActions.getCartData, (state, { cart }) => ({ ...state, cart })),
  on(CartActions.updateCart, (state, { cart }) => ({ ...state, cart })),
  on(CartActions.getCartProducts, (state, { items }) => CartAdapter.setAll(items, state)),
  on(CartActions.addItem, (state, { item }) => {
    const existingItem = state.entities[item.product];

    if (existingItem) {
      return CartAdapter.updateOne(
        {
          id: item.product,
          changes: {
            quantity: existingItem.quantity + item.quantity
          }
        },
        state
      );
    }

    return CartAdapter.addOne(item, state);
  }),
  on(CartActions.updateCartItem, (state, { item }) => CartAdapter.upsertOne(item, state)),
  on(CartActions.mergeCartItems, (state, { items }) => {
    let updatedState = state;

    items.forEach(item => {
      const existingItem = updatedState.entities[item.product];

      if (existingItem) {
        updatedState = CartAdapter.updateOne(
          {
            id: item.product,
            changes: {
              quantity: existingItem.quantity + item.quantity
            }
          },
          updatedState
        );
      } else {
        updatedState = CartAdapter.addOne(item, updatedState);
      }
    });

    return updatedState;
  }),
  on(CartActions.removeItem, (state, { id }) => CartAdapter.removeOne(id, state)),
  on(CartActions.clearCart, (state) => CartAdapter.removeAll(state)),
  on(CartActions.getCartSuccess, (state, { getCartSuccess }) => ({ ...state, getCartSuccess })),
  on(CartActions.updateCartSuccess, (state, { updateCartSuccess }) => ({ ...state, updateCartSuccess })),
  on(CartActions.getCartFailure, (state, { getCartFailure }) => ({ ...state, getCartFailure })),
  on(CartActions.updateCartFailure, (state, { updateCartFailure }) => ({ ...state, updateCartFailure })),
  on(CartActions.clearCartError, (state) => ({
    ...state,
    getCartFailure: null!,
    updateCartFailure: null!,
  })),
  on(CartActions.clearCartSuccess, (state) => ({
    ...state,
    getCartSuccess: null!,
    updateCartSuccess: null!,
  })),
);